'use client';

import { addItemsBulk, getCartCookie, setCartCookie, useCart } from '@qlevr/shared/providers';
import { fetchFreeShipping, getCart } from '@qlevr/shared/services';
import isEmpty from 'lodash.isempty';
import { useParams } from 'next/navigation';
import { useQueryState } from 'nuqs';
import { useEffect, useState } from 'react';

export function CartReferralId() {
  const { locale } = useParams<{ locale: string }>();
  const {
    setCartIdCookie,
    setCartData,
    cart: cartData,
    freeShippingTreshold,
    setFreeShippingTreshold,
    handleLoggedIn,
  } = useCart();

  const [cartIdState, setCartIdState] = useQueryState('cartId');
  const [referralCartIdString, setReferralCartIdString] = useState<string | null>(null);
  const [referralFetched, setReferralFetched] = useState(false); // State to track if referral has been fetched

  useEffect(() => {
    const fetchReferralCartData = async () => {
      let latestFreeShippingTreshold = freeShippingTreshold;
      const currentCartId = await getCartCookie();
      const referralCartId = cartIdState;
      let oldCartData = cartData;

      if (!latestFreeShippingTreshold) {
        latestFreeShippingTreshold = await fetchFreeShipping();
        setFreeShippingTreshold(latestFreeShippingTreshold);
      }

      if (!cartData) {
        const res = await getCart(locale, currentCartId);
        oldCartData = { ...res, freeShipping: latestFreeShippingTreshold || null };
        setCartData(oldCartData);
      }

      if (referralCartId) {
        setCartIdCookie(referralCartId);
        handleLoggedIn(referralCartId);
      } else {
        if (currentCartId) {
          setCartIdCookie(currentCartId);
        }
        // call handleLoggedIn even if currentCartId is null
        handleLoggedIn(currentCartId);
      }

      if (referralCartId !== null) setReferralCartIdString(referralCartId);

      if (!referralCartIdString || referralFetched || isEmpty(oldCartData)) {
        setCartIdState(null);
        return;
      }

      if (currentCartId === referralCartIdString) {
        setCartIdState(null);
        return;
      }

      const cartItems = oldCartData.items.map((item) => ({
        id: item.variantId,
        quantity: item.quantity,
      }));

      try {
        console.log('Adding items to cart:', cartItems);
        await addItemsBulk(locale, referralCartIdString, cartItems);
        await setCartCookie(referralCartIdString);

        const res = await getCart(locale, referralCartIdString);
        setCartData({
          ...res,
          freeShipping: latestFreeShippingTreshold || null,
        });

        setCartIdState(null);
        setReferralFetched(true);
      } catch (error) {
        console.error('Error adding items to cart:', error);
      }
    };

    fetchReferralCartData();
  }, [
    cartIdState,
    cartData,
    locale,
    freeShippingTreshold,
    setCartIdCookie,
    setCartData,
    referralCartIdString,
    referralFetched,
    setCartIdState,
  ]);

  return null;
}

export default CartReferralId;
